module.exports = __webpack_public_path__ + "static/media/DownloadOurApp.aea49ef9.png";